import { gql } from '@src/lib/gql'

/**
 * Draft a custom reply into the desk composer. `scope` is `last` (the latest sent message) or
 * `thread` (the latest sent messages). `includeFiles` inlines files on member messages.
 * `instruction` is optional. Nothing is sent, and the rule run is left alone.
 */
export const GENERATE_CRM_REPLY = gql`
  mutation GenerateCrmReply($input: GenerateCrmReplyInput!) {
    generateCrmReply(input: $input) {
      body
    }
  }
`
